import { dynamicLoader } from '~/utils';

export const SubtradeSelector = dynamicLoader({
  name: 'SubtradeSelector',
  importFunc: () => import('./subtrade-selector'),
});